<script>
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    PageHeader,
    NextButton,
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      inboxName: '',
      idInstance: '',
      apiTokenInstance: '',
      apiUrl: 'https://api.green-api.com',
    };
  },
  computed: {
    ...mapGetters({ uiFlags: 'inboxes/getUIFlags' }),
  },
  validations: {
    inboxName: { required },
    idInstance: { required },
    apiTokenInstance: { required },
  },
  methods: {
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;

      try {
        const maxChannel = await this.$store.dispatch('inboxes/createChannel', {
          name: this.inboxName?.trim(),
          channel: {
            type: 'max',
            provider_config: {
              id_instance: this.idInstance,
              api_token_instance: this.apiTokenInstance,
              api_url: this.apiUrl,
            },
          },
        });

        router.replace({
          name: 'settings_inboxes_add_agents',
          params: {
            page: 'new',
            inbox_id: maxChannel.id,
          },
        });
      } catch (error) {
        useAlert(
          error.message || this.$t('INBOX_MGMT.ADD.MAX.API.ERROR_MESSAGE')
        );
      }
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.MAX.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.MAX.DESC')"
    />
    <form
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.inboxName.$error }">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.LABEL') }}
          <input
            v-model="inboxName"
            type="text"
            :placeholder="$t('INBOX_MGMT.ADD.WHATSAPP.INBOX_NAME.PLACEHOLDER')"
            @blur="v$.inboxName.$touch"
          />
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.idInstance.$error }">
          <span>
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.ID_INSTANCE.LABEL') }}
          </span>
          <input
            v-model="idInstance"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.ID_INSTANCE.PLACEHOLDER')
            "
            @blur="v$.idInstance.$touch"
          />
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.apiTokenInstance.$error }">
          <span>
            {{
              $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_TOKEN_INSTANCE.LABEL')
            }}
          </span>
          <input
            v-model="apiTokenInstance"
            type="password"
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_TOKEN_INSTANCE.PLACEHOLDER'
              )
            "
            @blur="v$.apiTokenInstance.$touch"
          />
        </label>
      </div>

      <div class="flex-shrink-0 flex-grow-0">
        <label>
          <span>
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_URL.LABEL') }}
          </span>
          <input
            v-model="apiUrl"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP.GREEN_API.API_URL.PLACEHOLDER')
            "
          />
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.MAX.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
